import 'reflect-metadata';
import { Expose, plainToInstance, instanceToPlain } from 'class-transformer';

export class Country {
  id: number;
  name: string;

  @Expose({ name: 'iso_code_2' })
  isoCode2: string;

  @Expose({ name: 'iso_code_3' })
  isoCode3: string;

  @Expose({ name: 'phone_code' })
  phoneCode: string;

  constructor(
    id: number,
    name: string,
    isoCode2: string,
    isoCode3: string,
    phoneCode: string
  ) {
    this.id = id;
    this.name = name;
    this.isoCode2 = isoCode2;
    this.isoCode3 = isoCode3;
    this.phoneCode = phoneCode;
  }

  static fromJson(json: Record<string, any>): Country {
    return plainToInstance(Country, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
